class customWishlist extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.loadWishlist();
    }

    getWishlistId() {
        const cookies = decodeURIComponent(document.cookie).split(';');
        const cookieString  = 'wishlist_id=';

        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();

            if (cookie.indexOf(cookieString) === 0) {
                return cookie.substring(cookieString.length);
            }
        }

        return null;
    }

    async loadWishlist() {
        const wishlistId = this.getWishlistId();
        if (!wishlistId) {
            this.displayNoProductsMessage();
            return;
        }

        try {
            const response = await fetch('/a/wishlist?type=api&wishlistid=' + wishlistId + '&version=1');

            const data = await response.text();
            const wishlistData = JSON.parse(data);

            if (wishlistData.items?.length) {
                this.loadWishlistItems(wishlistData);
            } else {
                this.displayNoProductsMessage();
            }
        } catch (error) {
            this.displayNoProductsMessage();
        }
    }

    async loadWishlistItems(wishlistData) {
        let fetchArray = wishlistData.items.map(item => fetch("/products/" + item.handle + "/?sections=custom-wishlist-item"));

        const responses = await Promise.all(fetchArray);
        const jsonResponses = await Promise.all(responses.map(res => res.json()));
        const fragment = document.createDocumentFragment();

        jsonResponses.forEach(response => {
            const customWishlistItemHTML = response['custom-wishlist-item'];
            const html = new DOMParser().parseFromString(customWishlistItemHTML, 'text/html');
            const wishlistItem = html.querySelector('custom-wishlist-item');

            wishlistItem && fragment.appendChild(wishlistItem);

        });
        
        this.appendChild(fragment);
    }

    displayNoProductsMessage() {
        this.querySelector('.empty-wishlist')?.classList.remove('tw-hidden');
    }
}

customElements.define('custom-wishlist', customWishlist);


class WishlistButton extends HTMLElement {
    constructor() {
        super();
        this.isRemove = Boolean(this.dataset.remove);
      }

    connectedCallback() {
        this.addEventListener('click', (event) => {
        const smartWishlist = this.querySelector('.smartwishlist');

        const dataProduct = smartWishlist.dataset.product;
        const dataVariant = smartWishlist.dataset.variant;

        if (this.isRemove) {
            event.preventDefault();
            RemoveFromSmartWishlist(dataProduct, dataVariant);
            window.location.reload(); 
            return;
        }

        smartWishlist.click();
    });
  }
} 
  
customElements.define('wishlist-button', WishlistButton);